import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as EscLogoSVG } from '../../assets/icons/escape-plan.svg';
import { useRoot } from '../../context/RootProvider';
import { Typography } from '../../designComponents';
import ActiveProfile from './ActiveProfile';
import NotificationPopover from './NotificationPopover';
import {
  HeaderNavContainerStyled,
  LogoWrapper,
  ProfileNotificationContainer,
} from './style';

const HeaderNav = () => {
  const navigate = useNavigate();
  const { auth } = useRoot();
  return (
    <HeaderNavContainerStyled>
      <LogoWrapper onClick={() => navigate('/dashboard')}>
        <EscLogoSVG className="esc-logo" />
        <div className="logo-desc">
          <Typography variant="caption" fontColor="dark" strong>
            Evacuation Plans
          </Typography>
          <Typography variant="smallText">Saas Application</Typography>
        </div>
      </LogoWrapper>
      <ProfileNotificationContainer>
        {auth?.isOnboardingCompleted && <NotificationPopover />}
        <ActiveProfile />
      </ProfileNotificationContainer>
    </HeaderNavContainerStyled>
  );
};

export default HeaderNav;
